import { Suspense, useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { I18nProvider } from '../_metronic/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core'
import { MasterInit } from '../_metronic/layout/MasterInit'
import AuthInit from './modules/auth/redux/AuthInit'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Loading } from './utils/loadingR/Loading'
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../setup';
import { cleanSessionMinute } from './pages/minutas/minutaFood/services/update-minuta/update-minuta.service'
import moment from 'moment';
moment.locale('es');
const App = () => {
  const open: any = useSelector<RootState>(({ auth }) => auth.showLoading, shallowEqual);
  const location = useLocation();
  useEffect(() => {
    if (!location.pathname.includes('minutas/minutaFood')) {
      cleanSessionMinute();
    }
  }, [location]);
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <ToastContainer limit={5} />
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
            <Outlet />
            <MasterInit />
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
      <Loading
        open={open}
      />
    </Suspense>
  )
}

export { App }
